var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"tag-container"},[_c('input',{staticClass:"input_mutiple",attrs:{"placeholder":"メールアドレス"},on:{"keyup":_vm.tagkeyUpChange,"blur":_vm.clickOutInput}})])])}
var staticRenderFns = []

export { render, staticRenderFns }